var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDroughts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.83 19.52c-28.898.023-61.718 16.366-86.002 55.16 70.773-24.38 69.905 19.077 130.02 36.95 12.785 18.24 21.513 41.086 27.45 72.214 1.056 9.14 1.425 18.935 1.495 29.078.16 23.53-1.74 48.726-3.072 69.72v.008c-.405 6.982 2.976 17.98 9.282 29.364 2.745 4.956 6.048 9.978 9.584 14.9 2.945-59.286 1.044-113.128 11.27-161.432 7.12-19.412 16.723-35.71 28.833-49.156 67.6-14.804 59.14-58.506 140.966-33.137-32.607-39-72.186-55.092-104.357-54.516-43.914.786-74.014 32.628-53.743 79.654-11.398 13.628-20.738 29.502-27.87 47.6-5.473-19.157-12.575-35.512-21.55-49.703 14.37-51.287-19.7-86.736-62.307-86.704zm35.234 169.918l-75.488 1.767-69.416 94.99 72.125 67.22 89.992-8.677-89.04 36.268-57.38-54.893 37.702 84.155 110.41 28.816-99.382-4.197 5.566 12.425L294.17 494.85 422 423.97v-.01l-31.676-45.116-94.816 42.367 99.135-72.116 28.097 41.947 1.78-79.19-66.54-78.248-55.644-12.608-24.406 36.445 6.95 26.154-9.353 14.8c-.525 15.73-1.216 31.995-2.38 48.768l23.2 32.524-36.1 41.71 15.515 31.862-37.116-35.465 33.95-39.223-11.094-15.55-4.88-5.268c-10.016-10.814-19.717-23.594-26.968-36.682-4.9-8.843-8.81-17.798-10.6-26.716l-18.118-36.536L216.27 217.8l.554-.048-14.76-28.315z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroughts);
export default __webpack_public_path__ + "static/media/droughts.7d24e27aa884d3811a746a89bb87c7b1.svg";
export { ForwardRef as ReactComponent };